import config from "../config";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "./utils";
import { LawFirm } from "../../../api/src/types";
import type {
  AdminPostLawFirmResponse,
  AdminPostLawFirmRequest,
  LawFirmsAdminGetResponse,
  AdminGetSingleLawFirmResponse,
  AdminPatchLawFirmResponse,
  AdminPatchLawFirmRequest,
  AdminGetLawFirmLeadResponse,
} from "../../../api/src/admin/law-firms/route";

export const lawFirmsApi = createApi({
  reducerPath: "lawFirmsApi",
  baseQuery: fetchBaseQuery({ baseUrl: config.api, prepareHeaders }),
  tagTypes: ["LawFirm"],
  endpoints: (builder) => ({
    getLawFirms: builder.query<LawFirm[], void>({
      query: () => ({
        url: "law-firms",
        method: "GET",
      }),
      providesTags: ["LawFirm"],
    }),
    adminGetLawFirms: builder.query<LawFirmsAdminGetResponse, void>({
      query: () => ({
        url: "admin/law-firms",
        method: "GET",
      }),
      providesTags: ["LawFirm"],
    }),
    adminCreateLawFirm: builder.mutation<
      AdminPostLawFirmResponse,
      AdminPostLawFirmRequest
    >({
      query: (body) => ({
        url: "admin/law-firms",
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["LawFirm"],
    }),
    adminGetSingleLawFirm: builder.query<
      AdminGetSingleLawFirmResponse,
      { lawFirmId: string }
    >({
      query: ({ lawFirmId }) => ({
        url: `admin/law-firms/${lawFirmId}`,
        method: "GET",
      }),
      providesTags: ["LawFirm"],
    }),
    adminPatchLawFirm: builder.mutation<
      AdminPatchLawFirmResponse,
      AdminPatchLawFirmRequest & { lawFirmId: string }
    >({
      query: ({ lawFirmId, ...body }) => ({
        url: `admin/law-firms/${lawFirmId}`,
        method: "PATCH",
        body: body,
      }),
      invalidatesTags: ["LawFirm"],
    }),
    adminGetLawFirmLead: builder.query<
      AdminGetLawFirmLeadResponse,
      { lawFirmId: string }
    >({
      query: ({ lawFirmId }) => ({
        url: `admin/law-firms/${lawFirmId}/lead`,
        method: "GET",
      }),
      providesTags: ["LawFirm"],
    }),
  }),
});

export const {
  useGetLawFirmsQuery,
  useAdminGetLawFirmsQuery,
  useAdminCreateLawFirmMutation,
  useAdminGetSingleLawFirmQuery,
  useAdminPatchLawFirmMutation,
  useAdminGetLawFirmLeadQuery,
} = lawFirmsApi;
